import Styled from 'styled-components'
import { maxQuery, minQuery } from '../../../../helpers'

export default Styled.div`
    div.adminForm--container {
        padding-top: 4em;
        padding-bottom: 2em;
        
        header {
            text-align: center;
            h2 {
                margin-bottom: 1em;
                font-weight: 500;
                font-size: 1.4rem;
            }
            p {
                font-size: 0.9rem;
                color: #fff;
            }
        }
        
    }

    div.bike_list{
        display:flex;
        align-items:center;
        justify-content: space-between;
        margin-bottom:20px;
    }

    input[type="checkbox"].bike_checkbox {
        background:#1b203a;
        border-radius:99px;
        border:1px solid #fff;
    }
    div.bike_id{
        font-size:10px;
    }
    div.BikeScroll{
        ${({ theme }) => theme.mixins.scrollbar};
    }
`
